import { SingleValueCardColor, SingleValueCardType } from "constants/index";

export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 3,
});

export const asCurrency = (value: number) => currencyFormatter.format(value);

export const asPercentage = (value: number) => `${value.toFixed(2)}%`;

export const formatValueWithSign = (
  value: number,
  type: SingleValueCardType,
) => {
  if (type === SingleValueCardType.CURRENCY) {
    return asCurrency(value);
  } else if (type === SingleValueCardType.PERCENTAGE) {
    return value > 0 ? `+${asPercentage(value)}` : asPercentage(value);
  } else if (type === SingleValueCardType.NUMBER) {
    return new Intl.NumberFormat("en-US").format(value);
  }
  return value.toString();
};

export const formatValue = (value: number, type: SingleValueCardType) => {
  if (type === SingleValueCardType.CURRENCY) {
    return asCurrency(value);
  } else if (type === SingleValueCardType.PERCENTAGE) {
    return `${asPercentage(value)}`;
  } else if (type === SingleValueCardType.NUMBER) {
    return new Intl.NumberFormat("en-US").format(value);
  }
  return value.toString();
};
